import { Toaster } from "./components/ui/sonner";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { useEffect, useState } from "react";
import { Hero } from "./components/Hero";
import { ServicesGrid } from "./components/ServicesGrid";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { ProjectsShowcase } from "./components/ProjectsShowcase";
import { AboutSection } from "./components/AboutSection";
import { IrrigationSolutions } from "./components/IrrigationSolutions";
import { DigitalAgriculture } from "./components/DigitalAgriculture";
import { Testimonials } from "./components/Testimonials";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import SupportPage from "./pages/Support";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { AboutPage } from "./pages/About";

function AppContent() {
  const { language } = useLanguage();
  const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : '');
  
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const isSupportPage = typeof window !== 'undefined' && window.location.pathname === '/support';
  const isPrivacyPolicyPage = hash === '#privacy-policy';
  const isAboutPage = hash === '#about-us';

  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      {isSupportPage ? (
        <SupportPage />
      ) : isAboutPage ? (
        <AboutPage />
      ) : isPrivacyPolicyPage ? (
        <PrivacyPolicy />
      ) : (
        <>
          <Toaster position="top-right" richColors />
          <Hero />
          <ServicesGrid />
          <WhyChooseUs />
          <ProjectsShowcase />
          <AboutSection />
          <IrrigationSolutions />
          <DigitalAgriculture />
          <Testimonials />
          <ContactSection />
          <Footer />
        </>
      )}
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}